// @owners { team: patients }
import { Toast, type ToastElement } from '@alto/design-system';
import React from 'react';
import { ADD_TO_UPCOMING_DELIVERY_ERROR_MESSAGE } from '../constants';

export const showAddToUpcomingDeliveryErrorToast = (
  addToast: (toast: ToastElement) => void,
  message: string = ADD_TO_UPCOMING_DELIVERY_ERROR_MESSAGE,
): void => {
  addToast(
    <Toast
      dismissible
      duration={5000}
      variant="error"
    >
      {message}
    </Toast>,
  );
};
